import { FC, PropsWithChildren } from 'react';
import { useLocation } from 'react-router';
import { z } from 'zod';
import { ActivityType } from '@/model/Activity/types';
import { toClassNames } from '@/utils';

type SessionLayoutProps = {
  className?: string;
};

const useActivityType = () => {
  const location = useLocation();
  const parsedState = z
    .object({
      activityType: z.nativeEnum(ActivityType),
    })
    .safeParse(location.state);
  return parsedState.success ? parsedState.data.activityType : undefined;
};

const getActivityBgColor = (activityType: ActivityType | undefined): string => {
  switch (activityType) {
    case ActivityType.SimpleQuiz:
      return 'bg-revamp-cobalt-400';
    case ActivityType.CreateYourOwnResponse:
      return 'bg-revamp-cobalt-400';
    case ActivityType.VLMultipleChoices:
      return 'bg-revamp-yellow-400';
    case ActivityType.ModelAnswerAndVocabPronunciationPractice:
      return 'bg-revamp-teal-400';
    case ActivityType.OESimple:
      return 'bg-revamp-sky-200';
    case ActivityType.OEVocabLearning:
      return 'bg-revamp-sky-200';
    case ActivityType.OEScaffolding:
      return 'bg-revamp-sky-200';
    case ActivityType.OpenEnded:
      return 'bg-revamp-sky-200';
    default:
      return 'bg-revamp-cobalt-400';
  }
};

const SessionLayout: FC<PropsWithChildren<SessionLayoutProps>> = ({ children, className }) => {
  const activityType = useActivityType();

  return (
    <div
      className={toClassNames(
        'flex w-full flex-col',
        'bg-[length:100vw_100vh] bg-fixed bg-center bg-no-repeat',
        'h-svh overflow-auto',
        getActivityBgColor(activityType),
        className
      )}
    >
      {children}
    </div>
  );
};

export default SessionLayout;
